import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDateTimeLocale } from './dateTimeInternationalization';

const useDateTimeInternationalization = () => {
  const [abbreviatedWeekdays, setAbbreviatedWeekdays] = useState([]);
  const { i18n } = useTranslation();

  useEffect(() => {
    const locale = getDateTimeLocale(i18n.language);
    const abbreviatedWeekdaysArr = [...Array(7)].map((x, i) => {
      // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      return locale.localize.day(i, { width: 'abbreviated' });
    });
    // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    setAbbreviatedWeekdays(abbreviatedWeekdaysArr);
  }, []);

  return {
    abbreviatedWeekdays,
  };
};

export default useDateTimeInternationalization;
